export default __webpack_public_path__ + "static/media/music.065fe6df.mp3";